import { createContext } from 'react';

export const ResizeContext = createContext({
  isMobile: false
});